import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography
} from "@mui/material";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import { t } from "i18next";
import { useEffect, useState } from "react";

export default function ModalCreateConquestMode({
    open,
    row,
    onClose,
    onSubmit
}: {
    open: boolean;
    row: any;
    onClose: () => void;
    onSubmit: (data: any) => void;
}) {
    const [rowsState, setRowsState] = useState<any[]>([]);

    useEffect(() => {
        if (row) setRowsState(row);
    }, [row]);

    const columns: GridColDef[] = [
        {
            field: "campaign_name",
            headerName: "Campaign",
            flex: 1,
            minWidth: 180,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "ad_group_name",
            headerName: "Ad Group",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
        },
        {
            field: "keyword",
            headerName: "Keyword",
            flex: 1,
            disableColumnMenu: true,
            sortable: false,
        },
    ];

    return (
        <Dialog
            open={open && !!row}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    color: "#FFF",
                },
            }}
        >
            <DialogTitle sx={{
                padding: "24px",
                backgroundColor: '#f4f7fb'
            }}>
                <Typography
                    sx={{
                        color: '#333C47',
                        fontFamily: '"Public Sans"',
                        fontSize: '18px',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        lineHeight: '100%',
                    }}
                >
                    {`Deactivate keyword${row?.length > 1 ? 's' : ''}`}
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ bgcolor: '#f4f7fb' }}>
                <Box
                    sx={{
                        color: "#FFF",
                        border: "none",
                        "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: "#FAFBFB",
                            borderRadius: "12px",
                            color: "rgba(99, 115, 129, 1)",
                            fontWeight: 500,
                        },
                        "& .MuiDataGrid-cell": {
                            borderBottom: "0px",
                        },
                        "& .MuiDataGrid-row": {
                            backgroundColor: "rgba(255, 0, 0, 0.1)", // couleur par défaut de la ligne
                            "&:hover": {
                                backgroundColor: "rgba(255, 0, 0, 0.15)", // couleur au hover
                            },
                        }
                    }}
                >
                    <DataGridPro
                        rows={rowsState || []}
                        columns={columns}
                        getRowId={(r) => r.id}
                        disableRowSelectionOnClick={true}
                        hideFooter
                        autoHeight
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ bgcolor: '#f4f7fb' }}>
                <Button variant="contained" color="inherit"
                    onClick={() => {
                        if (onSubmit) {
                            onSubmit(rowsState);
                        }
                        onClose();
                    }}
                    sx={{
                        borderRadius: '8px',
                        background: '#181818',
                        color: "rgba(255, 255, 255, 1)",
                        border: 'none',
                    }}>
                    Deactivate
                </Button>

                <Button onClick={onClose} variant="outlined" color="inherit"
                    sx={{
                        borderRadius: '8px',
                        background: 'rgba(145, 158, 171, 0.12)',
                        color: "rgba(145, 158, 171, 1)",
                        border: 'none',
                    }}>
                    {t('dashboard.global.cancel')}
                </Button>
            </DialogActions>
        </Dialog >
    );
}